var voted_users_default = {
  "container": "vXf5M",
  "webview": "K4MR9",
  "avatar_list": "_-6rk5",
  "avatar": "CtFn3",
  "user_avatar": "oAVhr",
  "modal": "uYnsJ",
  "voted_users_modal": "txNPb",
  "overlay": "m-DP1",
  "user_card": "_2Y7f0",
  "user_name": "_9Ae-O",
  "voted_users_modal_header": "ZkwaF",
  "cta": "JErs3",
  "close_icon": "Vy5h-",
  "title": "dEzr6",
  "member_list_container": "_9BnHi",
  "member_list": "iIBd2",
  "loader": "RspVX",
  "anonymous_counter": "lhH1Y",
  "spinner": "jeB0K",
  "spin": "rrXor"
};
export {
  voted_users_default as default
};
//# sourceMappingURL=voted-users-scss.js.map
